import { createBrowserHistory } from 'history';

/**
 * For some reason in jest createBrowserHistory isn't a function
 * Adding this check to prevent further issues
 */
// if (createBrowserHistory) {
const history = createBrowserHistory();
// }

export default history;
